<template>
  <v-col :cols="cols">
    <v-card class="mx-1 mt-1 mb-1">
      <v-card-title class="pb-0">
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text class="pa-6 pt-0 pb-0">
        <v-row no-gutters>
          <v-col cols="6" class="my-auto">
            <span
              class=""
              :style="{ 'font-size': text_font_size, 'font-weight': 'bold' }"
              >{{ title_number }}
            </span>
          </v-col>
          {{ subTitle }}

          <!-- <v-col cols="12" class="my-auto">
            <span>
              {{ subTitle }}
            </span>
          </v-col> -->
          <v-spacer></v-spacer>
          <v-col class="mt-2">
            <span
              class="text-h5 font-weight-light"
            >
          {{ currentValue + unit }}
          </span>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-slider
              class="mt-4"
              :step=step
              :min="min"
              :max="max"
              v-model="currentValue"
              :disabled="disabled"
              @change="onSliderChange"
            >
            </v-slider>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
export default {
  props: {
    cols: {
      type: String,
      required: false,
      default: "4",
    },
    subTitle: {
      type: String,
      required: false,
    },
    title_number: {
      type: String,
      required: true,
    },
    text_font_size: {
      type: String,
      required: true,
    },
    control: {
      type: String,
      required: true,
    },
    step: {
      type: Number,
      default: 0.1,
      required: false,
    },
    decimals: {
      type: Number,
      default: 1,
      required: false,
    },
    controlVariable: {
      type: String,
      default: null,
      required: false,
    },
    value: {
      type: Number,
      required: true,
    },
    min: {
      type: Number,
      required: true,
    },
    max: {
      type: Number,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
    unit: {
      type: String,
      default: ' °C',
      required: false,
    }
  },
  data() {
    return {
      currentValue: this.value.toFixed(this.decimals),
    };
  },
  methods: {
    onSliderChange() {
      if (this.control == "max_hot_water_temperature") {
        this.$emit("maxHotWaterValChange", this.currentValue);
      } else if (this.control == "weather_adaptation_lower_limit") {
        this.$emit("weatherAdaptationLowerLimitValChange", this.currentValue);
      } else if (this.control == "weather_adaptation_upper_limit") {
        this.$emit("weatherAdaptationUpperLimitValChange", this.currentValue);
      } else if (this.control == "fixed_boiler_temperature") {
        this.$emit("fixedBoilerTemperatureValChange", this.currentValue);
      } else if (this.control == "iaq_set_offset") {
        this.$emit("setIAQTemperatureOffset", this.currentValue);
      } else if (this.control == "db") {
        this.$emit("setDeadband", this.currentValue);
      } else {
        this.$emit("defaultAction", this.currentValue, this.controlVariable);
      }
    },
  },
};
</script>

<style lang="scss">
@import "../../styles/app";

.dashboard-page {
  .page-title {
    padding-bottom: 20px;
    @include media-breakpoint-up(sm) {
      padding-bottom: 0;
    }
  }
  .apexcharts-legend-series {
    padding: 2px 5px 3px;
    display: flex;
    align-items: center;
    .apexcharts-legend-marker {
      margin-right: 8px;
    }
  }
  .main-chart-select {
    font-size: 1rem;
    margin-right: 10px;
    fieldset {
      border-width: 1px !important;
      border-color: $text-grey !important;
      color: $text-grey !important;
    }
    .v-select__selection {
      color: $text-color !important;
    }
  }
  .v-card {
    .v-card__text {
      .subtext {
        font-size: 1.142rem;
        font-weight: 400;
        color: $title-grey;
      }
      .subtext-index {
        font-size: 11px;
        color: $text-color;
        font-weight: 400;
      }
    }
  }
}

.v-menu__content {
  box-shadow: $card-shadow !important;
  .v-list-item__content .v-list-item__title {
    font-size: 1rem;
    font-weight: 400;
  }
}
.button-shadow {
  box-shadow: $button-shadow;
}

.v-slider__thumb {
  height: 16px !important;
  width: 16px !important;
}

.v-slider--horizontal .v-slider__track-container {
  height: 5px !important;
}
</style>
